import { Box } from '@spaceship-fspl/components';
import styled from 'styled-components';

export const PanelSection = styled(Box).attrs((props) => ({
  as: 'section',
  paddingTop: { xs: 'xl', md: 'xxl', lg: 'xxxl' },
  paddingBottom: { xs: 'xl', md: 'xxl', lg: 'xxxl' },
  ...props,
}))<React.ComponentProps<typeof Box>>``;
